import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref, onMounted } from 'vue';
import { defineMessages } from '@/lib/i18n';

import SdsSection8SkinProtectionForm from '@/views/dashboard/sdsDrawer/section8/SdsSection8SkinProtectionForm.vue';
import { SdsSection8 } from '@/interfaces/model/general/sds';
import { VForm } from 'vuetify/lib/components';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsTableSection8',
  props: {
  section8: {
    type: Object as PropType<SdsSection8>,
    required: true,
    default: () => ({}),
  },
  isValid: {
    type: Boolean,
    default: false,
  },
  isEditing: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:isValid", "update:section8"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'update:isValid', data: boolean): void;
  (e: 'update:section8', data: SdsSection8): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const m = defineMessages({
  deletedItem: '削除するアイテム',
});





const form = ref<InstanceType<typeof VForm> | null>(null);

const updateIsValid = (e: boolean) => {
  emits('update:isValid', e);
};

const updateProtectiveEquipmentOfSkin = (e: string) => {
  const data = { ...props.section8 };
  data.protective_equipment_of_skin = e;
  data.skin_protection = e == 'REQUIRED' ? 'あり' : '-';

  emits('update:section8', data);
};

onMounted((): void => {
  if (form.value) {
    form.value.validate();
  }
});

return { __sfc: true,m, props, emits, form, updateIsValid, updateProtectiveEquipmentOfSkin, SdsSection8SkinProtectionForm, sharedMessages }
}

})